import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import {
  GetCalenderByMonthAndYearDto,
  GetCalenderOrganizationEventByYearAndMonthDto,
} from 'src/app/core/api/models';
import { UserSessionService } from 'src/app/core/services/authentication/user-session.service';
import { LoggerService } from 'src/app/core/services/logger.service';
import { ApiNotificationService } from '../../../../core/services/api-notification.service';

@Component({
  selector: 'app-event-detail',
  templateUrl: './event-detail.component.html',
  standalone: false,
})
export class EventDetailComponent implements OnInit {
  //#region Properties
  title: string;
  model: GetCalenderOrganizationEventByYearAndMonthDto = {};
  selectedDayInfo: GetCalenderByMonthAndYearDto = {};

  //#endregion

  constructor(
    public apiNotificationService: ApiNotificationService,
    protected userSession: UserSessionService,
    private dialogRef: MatDialogRef<EventDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    protected elementRef: ElementRef,
    protected loggerService: LoggerService
  ) {
    this.title = data?.title;
    if (data.model) this.model = data?.model;
    (this.model = data?.event), (this.selectedDayInfo = data?.selectedDayInfo);
  }

  ngOnInit() {}

  //#region final methods

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    // this.unSubs();
    this.dialogRef.close(true);
  }

  //#endregion
}
